import { ReportStatusCounts } from 'src/features/monitoringDashboardAlpha/types'

/**
 * L1 のカード・テーブル列で表示するためのグループ別件数。
 *
 * API の7ステータスを、画面表示用の4グループ（実施済み／未実施／期間中／開始前）に束ねたもの。
 * 「未実施」「期間中」は内訳として「記録中（一時保存あり）」の件数も持つ
 * （カードに「(N件記録中)」と添える用）。
 */
export type ReportStatusGroups = {
  /** 実施済み = 期限内実施 + 期限後実施 */
  submitted: number
  /** 未実施（期限切れ） = 記録なし(notImplementedYet) + 記録中(recordingOverdue) */
  notImplemented: number
  /** 未実施のうち記録中（一時保存あり）の件数 = recordingOverdue */
  notImplementedRecording: number
  /** 期間中 = 記録なし(duringPeriod) + 記録中(recording) */
  duringPeriod: number
  /** 期間中のうち記録中（一時保存あり）の件数 = recording */
  duringPeriodRecording: number
  /** 開始前 */
  notStarted: number
  /** 全件数（7ステータスの合計） */
  total: number
}

/**
 * API の7ステータス件数を、L1 表示用の4グループ件数へ変換する。
 */
export const toReportStatusGroups = (
  counts: ReportStatusCounts,
): ReportStatusGroups => ({
  submitted: counts.implemented + counts.implementedAfterDeadline,
  notImplemented: counts.notImplementedYet + counts.recordingOverdue,
  notImplementedRecording: counts.recordingOverdue,
  duringPeriod: counts.duringPeriod + counts.recording,
  duringPeriodRecording: counts.recording,
  notStarted: counts.notStarted,
  total: counts.total,
})
